export const FacilityTypes = {
  ASSISTED_LIVING: 'Assisted Living',
  MEMORY_CARE: 'Memory Care',
  INDEPENDENT_LIVING: 'Independent Living',
  SKILLED_NURSING: 'Skilled Nursing',
} as const;

export type FacilityValueType = keyof typeof FacilityTypes;

export const FACILITY_TYPES_OPTIONS = Object.entries(FacilityTypes).map(
  ([value, label]) => ({ value, label })
);
